// extracted by mini-css-extract-plugin
export default {"wrapper":"NpcStorage_wrapper__53oWO","itemContainers":"NpcStorage_itemContainers__gXOaV","info":"NpcStorage_info__81kN-"};